import styled from 'styled-components';

export const TennisCalendarWrapper = styled.div`
  ${props => props.theme.colors.mainColor};
`;

export const TennisCourtesyMessage = styled.div`
  font-size: 18px;
  margin-top: 30px;
`;



// WEBPACK FOOTER //
// ./src/containers/TennisCalendar/styles.js